export { GeneralJournal } from './GeneralJournal';
